<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    v-on="$listeners || {}"
  >
    <template #item.id="{ header, item }">
      <router-link
        :to="header.getRoute(item)"
        v-text="item.user.id"
      />
    </template>

    <template #item.user="{ header, item }">
      <router-link
        :to="header.getRoute(item)"
        v-text="item.user.username"
      />
    </template>
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/UsersHistory/table-headers'
import BTable from '@/components/common/BTable.vue'


export default {
  name: 'BTableUsersHistory',
  components: {
    BTable,
  },
  inheritAttrs: false,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
